import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PcrMasterMix } from "../components/PcrMasterMix";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.pcr_tool_name()}
        toolPath="/pcr-master-mix-calculator"
      />
      <SciHeader title={m.pcr_h1()} intro={m.pcr_intro()} />
      <PcrMasterMix />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.pcr_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.pcr_ex1(), m.pcr_ex2(), m.pcr_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.pcr_faq_q1(), a: m.pcr_faq_a1() },
          { q: m.pcr_faq_q2(), a: m.pcr_faq_a2() },
          { q: m.pcr_faq_q3(), a: m.pcr_faq_a3() },
          { q: m.pcr_faq_q4(), a: m.pcr_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
